// src/components/StickyBookButton.js
import React from "react";
import "./StickyBookButton.css";
import whatsappicon from "../assets/whatsapp1.png";
import starIcon from "../assets/noto_star.svg";
import googleIcon from "../assets/devicon_google.svg";
import pawIcon from "../assets/pawIcon.svg";
import { navigateWithUTM } from "../utils/utmHelper";

const StickyBookButton = ({ isVisible }) => {
  return (
    // Add a conditional class based on the isVisible prop
    <div className={`sticky-button-container ${isVisible ? "visible" : ""}`}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          marginBottom: "8px",
        }}
      >
        <button
          className="sticky-book-now-btn"
          onClick={() => {
            navigateWithUTM("https://doodley.in/BookHomeVisit");
          }}
        >
          <img className="pawIcon" alt="paw" src={pawIcon} />
          <span className="book-now-button">BOOK NOW</span>
        </button>
        <a
          href="https://api.whatsapp.com/send?phone=919902356133&text=Hello%20Dr.Doodley%2C%20I%20need%20your%20assistance."
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={whatsappicon}
            alt="WhatsApp"
            style={{ width: "145px", height: "50px", marginTop: "8px" }}
          />
        </a>
      </div>

      <p className="hero-ratings">
        4.9 &nbsp;
        <img src={starIcon} alt="star" className="star" /> &nbsp;in &nbsp;
        <img src={googleIcon} alt="google" className="google" />
        &nbsp; Ratings | 20,000+ Pets Cured
      </p>
    </div>
  );
};

export default StickyBookButton;
